import { render } from "./RevealableInput.vue?vue&type=template&id=1afe64a1&scoped=true&lang=pug"
import script from "./RevealableInput.vue?vue&type=script&lang=ts"
export * from "./RevealableInput.vue?vue&type=script&lang=ts"

import "./RevealableInput.vue?vue&type=style&index=0&id=1afe64a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1afe64a1"

export default script